import { StepId } from '@feedyou/schema'

export const idGenerators = {
  aiDialogTool: (aiId: StepId, dialogToolId: string = 'default') => `${aiId}--${dialogToolId}`,

  switchCase: (switchId: StepId, caseId: string = 'default') => `${switchId}--${caseId}`,

  validatorCase: (promptId: StepId, validity: 'valid' | 'invalid') => `${promptId}--${validity}`,

  answer: (questionId: StepId, answerId: string) => `${questionId}--${answerId}`,

  step: (stepId: StepId) => stepId,

  // For explanation, see CheckpointType.NoProgress
  noProgress: (stepId: StepId) => `${stepId}--noProgress`
}
